// extracted by mini-css-extract-plugin
export default {"aboutContainer":"AboutSection_aboutContainer__et2gq","aboutText":"AboutSection_aboutText__BL+Rw"};